import { Skeleton } from 'antd';

interface Props {
  rows?: number;
  active?: boolean;
}

export function LoadingSkeleton({ rows = 4, active = true }: Props) {
  return (
    <div style={{ padding: 'var(--space-4)' }}>
      <Skeleton active={active} paragraph={{ rows }} />
    </div>
  );
}
